// extracted by mini-css-extract-plugin
module.exports = {"container":"HouseInfo_container___ER0t"};